import React, {useEffect} from 'react';
import MetisMenu from 'metismenujs';
import {Link, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const SidebarContent = () => {
  const location = useLocation();
  const {t} = useTranslation();

  useEffect(() => {
    const pathName = location.pathname;

    const initMenu = () => {
      new MetisMenu('#side-menu');
      let matchingMenuItem = null;
      const ul = document.getElementById('side-menu');
      const items = ul.getElementsByTagName('a');
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [location.pathname]);


  function activateParentDropdown(item) {
    item.classList.add('active');
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show');

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); // a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add('mm-active');
          }
        }
      }
      return false;
    }
    return false;
  }

  return (

    <React.Fragment>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">{t('Menu') }  </li>
          <li>
            <Link to="/#" className="waves-effect">
              <i className="bx bx-home-circle"/>
              <span className="badge badge-pill badge-info float-right">
                    03
              </span>
              <span>{t('Dashboards') }</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="/dashboard">{t('Default') }</Link></li>
              <li><Link to="/dashboard-saas">{t('Saas') }</Link></li>
              <li><Link to="/dashboard-crypto">{t('Crypto') }</Link></li>
            </ul>
          </li>

          <li className="menu-title">{t('Apps') }</li>

          <li>
            <Link to="calendar" className=" waves-effect">
              <i className="bx bx-calendar"></i>
              <span>{t('Calendar') }</span>
            </Link>
          </li>

          <li>
            <Link to="chat" className=" waves-effect">
              <i className="bx bx-chat"></i>
              <span className="badge badge-pill badge-success float-right">
                {t('New') }
              </span>
              <span>{t('Chat') }</span>
            </Link>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-store"></i>
              <span>{t('Ecommerce') }</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="ecommerce-products">{t('Products') }</Link>
              </li>
              <li>
                <Link to="ecommerce-product-detail">
                  {t('Product Detail') }
                </Link>
              </li>
              <li><Link to="ecommerce-orders">{t('Orders') }</Link></li>
              <li>
                <Link to="ecommerce-customers">{t('Customers') }</Link>
              </li>
              <li><Link to="ecommerce-cart">{t('Cart') }</Link></li>
              <li>
                <Link to="ecommerce-checkout">{t('Checkout') }</Link>
              </li>
              <li><Link to="ecommerce-shops">{t('Shops') }</Link></li>
              <li>
                <Link to="ecommerce-add-product">
                  {t('Add Product') }
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-bitcoin"></i>
              <span>{t('Crypto')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="crypto-wallet">{t('Wallet')}</Link></li>
              <li><Link to="crypto-buy-sell">{t('Buy/Sell')}</Link></li>
              <li><Link to="crypto-exchange">{t('Exchange')}</Link></li>
              <li><Link to="crypto-lending">{t('Lending')}</Link></li>
              <li><Link to="crypto-orders">{t('Orders')}</Link></li>
              <li>
                <Link to="crypto-kyc-application">
                  {t('KYC Application')}
                </Link>
              </li>
              <li>
                <Link to="crypto-ico-landing">{t('ICO Landing')}</Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-envelope"></i>
              <span>{t('Email')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="email-inbox">{t('Inbox')}</Link></li>
              <li><Link to="email-read">{t('Read Email')} </Link></li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-receipt"></i>
              <span>{t('Invoices')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="invoices-list">{t('Invoice List')}</Link></li>
              <li>
                <Link to="invoices-detail">{t('Invoice Detail')}</Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-briefcase-alt-2"></i>
              <span>{t('Projects')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="projects-grid">{t('Projects Grid')}</Link>
              </li>
              <li>
                <Link to="projects-list">{t('Projects List')}</Link>
              </li>
              <li>
                <Link to="projects-overview">
                  {t('Project Overview')}
                </Link>
              </li>
              <li><Link to="projects-create">{t('Create New')}</Link></li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-task"></i>
              <span>{t('Tasks')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="tasks-list">{t('Task List')}</Link></li>
              <li><Link to="tasks-kanban">{t('Kanban Board')}</Link></li>
              <li><Link to="tasks-create">{t('Create Task')}</Link></li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bxs-user-detail"></i>
              <span>{t('Contacts')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="contacts-grid">{t('User Grid')}</Link></li>
              <li><Link to="contacts-list">{t('User List')}</Link></li>
              <li><Link to="contacts-profile">{t('Profile')}</Link></li>
            </ul>
          </li>

          <li className="menu-title">Pages</li>
          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-user-circle"></i>
              <span>{t('Authentication')}</span>
            </Link>
            <ul className="sub-menu">
              <li><Link to="pages-login">{t('Login')}</Link></li>
              <li><Link to="pages-register">{t('Register')}</Link></li>
              <li>
                <Link to="pages-forget-pwd">
                  {t('Forget Password')}
                </Link>
              </li>
              <li>
                <Link to="auth-lock-screen">{t('Lock Screen')}</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-file"></i>
              <span>{t('Utility')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="pages-starter">{t('Starter Page')}</Link></li>
              <li>
                <Link to="pages-maintenance">{t('Maintenance')}</Link>
              </li>
              <li>
                <Link to="pages-comingsoon">{t('Coming Soon')}</Link>
              </li>
              <li><Link to="pages-timeline">{t('Timeline')}</Link></li>
              <li><Link to="pages-faqs">{t('FAQs')}</Link></li>
              <li><Link to="pages-pricing">{t('Pricing')}</Link></li>
              <li><Link to="pages-404">{t('Error 404')}</Link></li>
              <li><Link to="pages-500">{t('Error 500')}</Link></li>
            </ul>
          </li>

          <li className="menu-title">{t('Components')}</li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-tone"></i>
              <span>{t('UI Elements')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="ui-alerts">{t('Alerts')}</Link></li>
              <li><Link to="ui-buttons">{t('Buttons')}</Link></li>
              <li><Link to="ui-cards">{t('Cards')}</Link></li>
              <li><Link to="ui-carousel">{t('Carousel')}</Link></li>
              <li><Link to="ui-dropdowns">{t('Dropdowns')}</Link></li>
              <li><Link to="ui-grid">{t('Grid')}</Link></li>
              <li><Link to="ui-images">{t('Images')}</Link></li>
              <li><Link to="ui-lightbox">{t('Lightbox')}</Link></li>
              <li><Link to="ui-modals">{t('Modals')}</Link></li>
              <li>
                <Link to="ui-rangeslider">{t('Range Slider')}</Link>
              </li>
              <li>
                <Link to="ui-session-timeout">
                  {t('Session Timeout')}
                </Link>
              </li>
              <li>
                <Link to="ui-progressbars">{t('Progress Bars')}</Link>
              </li>
              <li><Link to="ui-sweet-alert">{t('Sweet-Alert')}</Link></li>
              <li>
                <Link to="ui-tabs-accordions">
                  {t('Tabs & Accordions')}
                </Link>
              </li>
              <li><Link to="ui-typography">{t('Typography')}</Link></li>
              <li><Link to="ui-video">{t('Video')}</Link></li>
              <li><Link to="ui-general">{t('General')}</Link></li>
              <li><Link to="ui-colors">{t('Colors')}</Link></li>
              <li><Link to="ui-rating">{t('Rating')}</Link></li>
              <li>
                <Link to="ui-notifications">{t('Notifications')}</Link>
              </li>
              <li>
                <Link to="ui-image-cropper">{t('Image Cropper')}</Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="waves-effect">
              <i className="bx bxs-eraser"></i>
              <span className="badge badge-pill badge-danger float-right">
                  6
              </span>
              <span>{t('Forms')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="form-elements">{t('Form Elements')}</Link>
              </li>
              <li>
                <Link to="form-validation">{t('Form Validation')}</Link>
              </li>
              <li>
                <Link to="form-advanced">{t('Form Advanced')}</Link>
              </li>
              <li><Link to="form-editors">{t('Form Editors')}</Link></li>
              <li>
                <Link to="form-uploads">{t('Form File Upload')} </Link>
              </li>
              <li>
                <Link to="form-xeditable">{t('Form Xeditable')}</Link>
              </li>
              <li>
                <Link to="form-repeater">{t('Form Repeater')}</Link>
              </li>
              <li><Link to="form-wizard">{t('Form Wizard')}</Link></li>
              <li><Link to="form-mask">{t('Form Mask')}</Link></li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-list-ul"></i>
              <span>{t('Tables')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="tables-basic">{t('Basic Tables')}</Link></li>
              <li>
                <Link to="tables-datatable">{t('Data Tables')}</Link>
              </li>
              <li>
                <Link to="tables-responsive">
                  {t('Responsive Table')}
                </Link>
              </li>
              <li>
                <Link to="tables-editable">{t('Editable Table')}</Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bxs-bar-chart-alt-2"></i>
              <span>{t('Charts')}</span>
            </Link>

            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="apex-charts">{t('Apex charts')}</Link></li>
              <li>
                <Link to="chartist-charts">{t('Chartist Chart')}</Link>
              </li>
              <li>
                <Link to="chartjs-charts">{t('Chartjs Chart')}</Link>
              </li>
              <li><Link to="e-charts">{t('E Chart')}</Link></li>
              <li><Link to="tui-charts">{t('Toast UI Chart')}</Link></li>
              <li>
                <Link to="sparkline-charts">
                  {t('Sparkline Chart')}
                </Link>
              </li>
              <li><Link to="charts-knob">{t('Knob Chart')}</Link></li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-aperture"></i>
              <span>{t('Icons')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="icons-boxicons">{t('Boxicons')}</Link></li>
              <li>
                <Link to="icons-materialdesign">
                  {t('Material Design')}
                </Link>
              </li>
              <li><Link to="icons-dripicons">{t('Dripicons')}</Link></li>
              <li>
                <Link to="icons-fontawesome">{t('Font awesome')}</Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-map"></i>
              <span>{t('Maps')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="false">
              <li><Link to="maps-google">{t('Google Maps')}</Link></li>
              <li><Link to="maps-vector">{t('Vector Maps')}</Link></li>
              <li><Link to="maps-leaflet">{t('Leaflet Maps')}</Link></li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="has-arrow waves-effect">
              <i className="bx bx-share-alt"></i>
              <span>{t('Multi Level')}</span>
            </Link>
            <ul className="sub-menu" aria-expanded="true">
              <li><Link to="#">{t('Level 1.1')}</Link></li>
              <li>
                <Link to="#" className="has-arrow">{t('Level 1.2')}</Link>
                <ul className="sub-menu" aria-expanded="true">
                  <li><Link to="#">{t('Level 2.1')}</Link></li>
                  <li><Link to="#">{t('Level 2.2')}</Link></li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default SidebarContent;


